/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, {
  useContext,
  useState,
  useRef,
  useMemo,
  useCallback,
} from 'react'
import { connect } from 'react-redux'
import {
  DatePicker,
  Button,
  Input,
  message,
  Modal,
  Upload,
  InputNumber,
} from 'antd'
// import R from 'ramda'
import { strCol, numCol, dateCol } from '@integec/grid-tools/lib/cols'
import { hasAccesPermits } from 'core/utils'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'

import {
  DatePickerContext,
  SpinContext,
  ErrorContext,
  JcTmpErrorContext,
} from 'context'
import { getEnvConfig, getPermitActions, getApiTargetInfo } from 'core'

import {
  retrievePjmRtImportData,
  importPjmRtImportData,
  getAuthorization,
  getCredentials,
} from 'api/pgads.js'

import * as Actions from 'core/EventActions'
import { isErrorContains } from '../core/component/JcTmpErrorDialog'
import { Label } from '../core/screen-util'
import { pjmRtLmpdelete, pjmRtLmpInsert } from '../api/pgads'
import CommonScreen from '../admin/component/CommonScreen'
// import moment from 'moment'
const gridHeader = [
  dateCol({
    ident: 'transdate',
    display: 'Trans Date',
    width: 100,
    isFiltered: true,
    isKey: true,
  }),
  strCol({
    ident: 'pnodeid',
    display: 'PNode Id',
    isKey: true,
    sortOrder: 'asc',
    width: 200,
  }),
  numCol({ ident: 'hour1', display: 'Hour 1', isFiltered: true }),
  numCol({ ident: 'hour2', display: 'Hour 2', isFiltered: true }),
  numCol({ ident: 'hour3', display: 'Hour 3', isFiltered: true }),
  numCol({ ident: 'hour4', display: 'Hour 4', isFiltered: true }),
  numCol({ ident: 'hour5', display: 'Hour 5', isFiltered: true }),
  numCol({ ident: 'hour6', display: 'Hour 6', isFiltered: true }),
  numCol({ ident: 'hour7', display: 'Hour 7', isFiltered: true }),
  numCol({ ident: 'hour8', display: 'Hour 8', isFiltered: true }),
  numCol({ ident: 'hour9', display: 'Hour 9', isFiltered: true }),
  numCol({ ident: 'hour10', display: 'Hour 10', isFiltered: true }),
  numCol({ ident: 'hour11', display: 'Hour 11', isFiltered: true }),
  numCol({ ident: 'hour12', display: 'Hour 12', isFiltered: true }),
  numCol({ ident: 'hour13', display: 'Hour 13', isFiltered: true }),
  numCol({ ident: 'hour14', display: 'Hour 14', isFiltered: true }),
  numCol({ ident: 'hour15', display: 'Hour 15', isFiltered: true }),
  numCol({ ident: 'hour16', display: 'Hour 16', isFiltered: true }),
  numCol({ ident: 'hour17', display: 'Hour 17', isFiltered: true }),
  numCol({ ident: 'hour18', display: 'Hour 18', isFiltered: true }),
  numCol({ ident: 'hour19', display: 'Hour 19', isFiltered: true }),
  numCol({ ident: 'hour20', display: 'Hour 20', isFiltered: true }),
  numCol({ ident: 'hour21', display: 'Hour 21', isFiltered: true }),
  numCol({ ident: 'hour22', display: 'Hour 22', isFiltered: true }),
  numCol({ ident: 'hour23', display: 'Hour 23', isFiltered: true }),
  numCol({ ident: 'hour24', display: 'Hour 24', isFiltered: true }),
  numCol({ ident: 'hour25', display: 'Hour 25', isFiltered: true }),
  modifierCol,
  modifiedDateCol,
]

const RealTimeLMP = ({ apiTargetInfo, envConfig, actionPermits }) => {
  // const [realTimeLMPData, setRealTimeLMPData] = useState([])

  const { setTmpError } = useContext(JcTmpErrorContext)
  const { selectedDate, setSelectedDate } = useContext(DatePickerContext)
  const { setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)

  const importPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [Actions.CHANGE_PERMISSIONS],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  // const [impDate, setImpDate] = useState(moment())
  // const [impHour, setImpHour] = useState(0)
  // const [impMin, setImpMin] = useState('00')

  // const fetchRealTimeLMPData = () => {
  //   setSpinning(true)
  //   retrievePjmRtImportData(apiTargetInfo)({
  //     date: selectedDate.format('YYYY-MM-DD'),
  //   }).fork(setError, data => {
  //     setSpinning(false)
  //     setRealTimeLMPData(data)
  //   })
  // }

  const importData = onRetrieve => {
    setSpinning(true)
    importPjmRtImportData(apiTargetInfo)({
      date: selectedDate.format('YYYY-MM-DD'),
    }).fork(setError, tmpData => {
      setSpinning(false)
      setTmpError(tmpData)
      if (!isErrorContains(tmpData)) {
        onRetrieve()
      }
    })
  }

  const [openImport, setOpenImport] = useState(false)

  const uploadRef = useRef()
  const manualImport = _ => {
    setOpenImport(true)
    // setSpinning(true)
    // retrievePjmRtImportData(apiTargetInfo)({
    //   date: selectedDate.format('YYYY-MM-DD'),
    // }).fork(setError, data => {
    //   setSpinning(false)
    //   // setRealTimeLMPData(data)
    //   if (data.length > 0) {
    //     setOpenImport(true)
    //   } else {
    //     // setOpenImport(true)
    //     // if (divref.current) divref.current.handleClick(uploadRef.current)

    //     // if (uploadRef.current) uploadRef.current.renderUpload()
    //   }
    // })
  }

  const fileProps = {
    name: 'file',
    action: `${apiTargetInfo.baseUrl}/pjm-admin/import-rt-lmp-manual`,
    method: 'POST',
    data: {},
    headers: getAuthorization(apiTargetInfo),
    ...getCredentials(apiTargetInfo),
  }

  const UploadCompo = ({ hide = false }) => {
    return (
      importPermission && (
        <Upload
          ref={uploadRef}
          {...fileProps}
          beforeUpload={_ => setSpinning(true)}
          onChange={data => {
            setSpinning(false)
            setOpenImport(false)
            if (
              data.file.response &&
              data.file.response.restfulStatus &&
              data.file.response.restfulStatus === 'FAILURE'
            ) {
              // setShowMessages(true)
              // setMessages([data.file.response])
              setError(data.file.response)
            } else if (data.file.response && data.file.response.length === 0) {
              //  if (data.file.response) {
              message.success('File imported successfully')

              // }
            } else if (data.file.response && data.file.response.length > 0) {
              setTmpError(data.file.response)
              if (!isErrorContains(data.file.response)) {
                message.success('File imported successfully')
              }
            }
          }}
          multiple={false}
          showUploadList={false}
        >
          <Button
            style={{
              maxWidth: hide ? '10px' : '100%',
              maxHeight: hide ? '10px' : '100%',
              padding: '0px',
              margin: '0px',
              border: '0px',
              paddingLeft: '20px',
              paddingRight: '20px',
            }}
            disabled={!importPermission}
            type="primary"
            //    ref={divref}
            icon="upload"
          >
            Import
          </Button>
        </Upload>
      )
    )
  }

  const [isRetrieved, setIsRetrieved] = useState(false)

  const onRetrieveData = data => {
    setIsRetrieved(data.length > 0)
    return data
  }

  const onCriteriaChange = _ => {
    setIsRetrieved(false)
  }

  const extraCriteriaAfterButton = ({ onRetrieve }) => {
    if (!importPermission) return <div />
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 0px',
          marginLeft: '5px',
        }}
      >
        {/* {!isRetrieved && <UploadCompo />} */}
        {!isRetrieved && (
          <Upload
            style={{ width: '100%', paddingLeft: '20px', paddingRight: '20px' }}
            ref={uploadRef}
            {...fileProps}
            beforeUpload={_ => setSpinning(true)}
            onChange={data => {
              setSpinning(false)
              setOpenImport(false)
              if (
                data.file.response &&
                data.file.response.restfulStatus &&
                data.file.response.restfulStatus === 'FAILURE'
              ) {
                // setShowMessages(true)
                // setMessages([data.file.response])
                setError(data.file.response)
              } else if (
                data.file.response &&
                data.file.response.length === 0
              ) {
                //  if (data.file.response) {
                message.success('File imported successfully')

                // }
              } else if (data.file.response && data.file.response.length > 0) {
                setTmpError(data.file.response)
                if (!isErrorContains(data.file.response)) {
                  message.success('File imported successfully')
                }
              }
            }}
            multiple={false}
            showUploadList={false}
          >
            <Button
              disabled={!importPermission}
              type="primary"
              //    ref={divref}
              icon="upload"
              style={{ width: '100%' }}
            >
              Import
            </Button>
          </Upload>
        )}
        {isRetrieved && (
          <Button
            onClick={manualImport}
            icon="import"
            type="primary"
            style={{ marginLeft: '10px' }}
            disabled={!importPermission}
          >
            CSV Import
            {/* <div style={{ maxHeight: '0px', minHeight: '0px' }}>
            <UploadCompo hide />
          </div> */}
          </Button>
        )}
        <Button
          onClick={_ => importData(onRetrieve)}
          icon="import"
          type="primary"
          style={{ marginLeft: '10px' }}
          disabled={!importPermission}
        >
          Auto Import
        </Button>

        <Modal
          visible={openImport}
          title="Confirm"
          onCancel={_ => setOpenImport(false)}
          destroyOnClose={false}
          iconType="question"
          footer={
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '100px 100px',
                columnGap: '5px',
                justifyContent: 'end',
              }}
            >
              <Button onClick={_ => setOpenImport(false)} type="danger">
                No
              </Button>
              <UploadCompo />
            </div>
          }
        >
          <div>
            Data have been imported previously. Do you want to re-import?
          </div>
        </Modal>
      </div>
    )
  }

  const defaultInsert = _ => ({
    transdatemom: selectedDate,
    transdate: selectedDate.format('YYYY-MM-DD'),
  })

  // const [insertData, setInsertData] = useState(defaultInsert())
  const [insertEvent, setInsertEvent] = useState(false)

  const HourInputNumber = useCallback(
    ({ hour, setInsertData, insertData }) => (
      <React.Fragment>
        <Label>Hour {hour} :</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData['hour' + hour]}
          onChange={val =>
            setInsertData({ ...insertData, ['hour' + hour]: val })
          }
        />
      </React.Fragment>
    ),
    []
  )

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <div
        style={{
          width: '100%',
          display: 'grid',
          gridTemplateColumns:
            '70px 120px 70px 100px 70px 80px 70px 80px 70px 80px 70px 80px 70px 80px',
          gap: '5px',
        }}
      >
        <Label>Date :</Label>
        <DatePicker
          allowClear={false}
          format="MM/DD/YYYY"
          value={insertData.transdatemom}
          onChange={d => {
            setInsertData({
              ...insertData,
              transdatemom: d,
              transdate: d.format('YYYY-MM-DD'),
            })
          }}
        />
        <Label>PNode :</Label>
        <Input
          value={insertData.pnodeid}
          onChange={e =>
            setInsertData({ ...insertData, pnodeid: e.target.value })
          }
        />
        <HourInputNumber
          setInsertData={setInsertData}
          insertData={insertData}
          hour={1}
        />
        <HourInputNumber
          setInsertData={setInsertData}
          insertData={insertData}
          hour={2}
        />
        <HourInputNumber
          setInsertData={setInsertData}
          insertData={insertData}
          hour={3}
        />
        <HourInputNumber
          setInsertData={setInsertData}
          insertData={insertData}
          hour={4}
        />
        <HourInputNumber
          setInsertData={setInsertData}
          insertData={insertData}
          hour={5}
        />
        <HourInputNumber
          setInsertData={setInsertData}
          insertData={insertData}
          hour={6}
        />
        <HourInputNumber
          setInsertData={setInsertData}
          insertData={insertData}
          hour={7}
        />
        <HourInputNumber
          setInsertData={setInsertData}
          insertData={insertData}
          hour={8}
        />
        <HourInputNumber
          setInsertData={setInsertData}
          insertData={insertData}
          hour={9}
        />
        <HourInputNumber
          setInsertData={setInsertData}
          insertData={insertData}
          hour={10}
        />
        <HourInputNumber
          setInsertData={setInsertData}
          insertData={insertData}
          hour={11}
        />
        <HourInputNumber
          setInsertData={setInsertData}
          insertData={insertData}
          hour={12}
        />
        <HourInputNumber
          setInsertData={setInsertData}
          insertData={insertData}
          hour={13}
        />
        <HourInputNumber
          setInsertData={setInsertData}
          insertData={insertData}
          hour={14}
        />
        <HourInputNumber
          setInsertData={setInsertData}
          insertData={insertData}
          hour={15}
        />
        <HourInputNumber
          setInsertData={setInsertData}
          insertData={insertData}
          hour={16}
        />
        <HourInputNumber
          setInsertData={setInsertData}
          insertData={insertData}
          hour={17}
        />
        <HourInputNumber
          setInsertData={setInsertData}
          insertData={insertData}
          hour={18}
        />
        <HourInputNumber
          setInsertData={setInsertData}
          insertData={insertData}
          hour={19}
        />
        <HourInputNumber
          setInsertData={setInsertData}
          insertData={insertData}
          hour={20}
        />
        <HourInputNumber
          setInsertData={setInsertData}
          insertData={insertData}
          hour={21}
        />
        <HourInputNumber
          setInsertData={setInsertData}
          insertData={insertData}
          hour={22}
        />
        <HourInputNumber
          setInsertData={setInsertData}
          insertData={insertData}
          hour={23}
        />
        <HourInputNumber
          setInsertData={setInsertData}
          insertData={insertData}
          hour={24}
        />
        <HourInputNumber
          setInsertData={setInsertData}
          insertData={insertData}
          hour={25}
        />
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'auto auto auto',
            gridColumnEnd: 'span 2',
            columnGap: '1px',
          }}
        >
          <Button onClick={_ => onAdd(true)} type="primary">
            Add
          </Button>
          <Button onClick={_ => onAdd(false)} type="primary">
            Add & Hide
          </Button>
          <Button onClick={onCancel} type="danger">
            Cancel
          </Button>
        </div>
      </div>
    )
  }

  const withCriteria = (s, p, su, sd) => ({ date: sd.format('YYYY-MM-DD') })

  const screenCriteria = (s, p, su, onCriteriaChnage, sd, onRetrieve) => (
    <DatePicker
      allowClear={false}
      format="MM/DD/YYYY"
      value={selectedDate}
      onChange={d => {
        setSelectedDate(d)
        onCriteriaChnage()
        onRetrieve({ selectedDate: d })
      }}
    />
  )

  return (
    <CommonScreen
      searchStyle={{ maxWidth: '100px' }}
      screenCriteria={screenCriteria}
      onCriteriaChange={onCriteriaChange}
      onRetrieveData={onRetrieveData}
      isAdminScreen
      withDatePicker={false}
      withCriteria={withCriteria}
      defaultInsertData={defaultInsert()}
      extraCriteriaAfterButton={extraCriteriaAfterButton}
      title="Real Time LMP"
      titleProps={{ minWidth: '150px' }}
      header={gridHeader}
      saveTask={pjmRtLmpInsert}
      retrieveTask={retrievePjmRtImportData}
      deleteTask={pjmRtLmpdelete}
      altBy={d => d.transdate + d.pnodeid}
      autoRetrieve={false}
      sortOptions={gridHeader}
      widthOffset={100}
      heightOffset={270}
      insertComp={insertEvent && insertComp}
      onInsertEvent={b => setInsertEvent(b)}
      insertCompHeight={450}
      autoFixColByKey={false}
      headerRowHeight={30}
    />
  )

  // return (
  //   <div
  //     css={{
  //       backgroundColor: '#f0f2f5',
  //       marginLeft: '20px',
  //       marginRight: '20px',
  //     }}
  //   >
  //     {openImport && extraCriteriaAfterButton()}
  //     <CriteriaRow>
  //       <Title
  //         css={{
  //           marginRight: '15px',
  //           marginBottom: '5px',
  //         }}
  //       >
  //         Real Time LMP
  //       </Title>
  //       <DatePicker
  //         allowClear={false}
  //         format="MM/DD/YYYY"
  //         value={selectedDate}
  //         onChange={d => {
  //           setSelectedDate(d)
  //           setRealTimeLMPData([])
  //         }}
  //       />

  //       <Button
  //         loading={spinning}
  //         onClick={fetchRealTimeLMPData}
  //         css={{ marginLeft: '10px' }}
  //         type="primary"
  //         icon="database"
  //       >
  //         Retrieve
  //       </Button>

  //       {importPermission && (
  //         <div
  //           style={{
  //             display: 'grid',
  //             gridTemplateColumns: 'auto auto',
  //             columnGap: '5px',
  //             marginLeft: '10px',
  //           }}
  //         >
  //           <Button
  //             onClick={manualImport}
  //             icon="import"
  //             type="primary"
  //             style={{ marginLeft: '10px' }}
  //           >
  //             Manual CSV Import
  //           </Button>
  //           <Button
  //             onClick={importData}
  //             icon="import"
  //             type="primary"
  //             style={{ marginLeft: '10px' }}
  //           >
  //             Auto Import
  //           </Button>
  //         </div>
  //       )}

  //       {/* <div
  //         style={{
  //           marginLeft: '50px',
  //           border: '1px solid black',
  //           // width: '250px',
  //           padding: '2px',
  //           display: 'grid',
  //           gridTemplateColumns: '100px 150px 80px 80px 150px',
  //           gridGap: '5px',
  //         }}
  //       >
  //         <div
  //           style={{
  //             display: 'grid',
  //             justifyContent: 'center',
  //             alignContent: 'center',
  //           }}
  //         >
  //           Import for :
  //         </div>
  //         <DatePicker
  //           onChange={setImpDate}
  //           value={impDate}
  //           format="MM/DD/YYYY"
  //           allowClear={false}
  //         />
  //         <Select onChange={setImpHour} value={impHour}>
  //           {R.range(1, 25).map(i => (
  //             <Select.Option value={i - 1} key={i - 1}>
  //               {i}
  //             </Select.Option>
  //           ))}
  //         </Select>

  //         <Select onChange={setImpMin} value={impMin}>
  //           <Select.Option value="00" key="00">
  //             00
  //           </Select.Option>
  //           <Select.Option value="05" key="05">
  //             05
  //           </Select.Option>
  //           <Select.Option value="10" key="10">
  //             10
  //           </Select.Option>
  //           <Select.Option value="15" key="15">
  //             15
  //           </Select.Option>
  //           <Select.Option value="20" key="20">
  //             20
  //           </Select.Option>
  //           <Select.Option value="25" key="25">
  //             25
  //           </Select.Option>
  //           <Select.Option value="30" key="30">
  //             30
  //           </Select.Option>
  //           <Select.Option value="35" key="35">
  //             35
  //           </Select.Option>
  //           <Select.Option value="40" key="40">
  //             40
  //           </Select.Option>
  //           <Select.Option value="45" key="45">
  //             45
  //           </Select.Option>
  //           <Select.Option value="50" key="50">
  //             50
  //           </Select.Option>
  //           <Select.Option value="55" key="55">
  //             55
  //           </Select.Option>
  //         </Select>

  //       </div> */}

  //       <div css={{ flex: '1 1 0px' }} />
  //       <Input.Search
  //         placeholder="Filter"
  //         value={fuzzyFilter}
  //         css={{ marginRight: '20px', flex: '0 0 200px' }}
  //         onChange={e => setFuzzyFilter(e.target.value)}
  //       />
  //       <ExportComponent
  //         getData={
  //           exportDataComponent
  //             ? _ => exportDataComponent(GridData, realTimeLMPData, fuzzyFilter)
  //             : undefined
  //         }
  //         data={realTimeLMPData}
  //         headers={gridHeader}
  //         fileName={`Real Time LMP-${selectedDate.format(
  //           'YYYY-MM-DD HH-mm-ss'
  //         )}`}
  //         btnStyle={{ marginRight: '10px' }}
  //         disabled={realTimeLMPData.length <= 0}
  //       />
  //     </CriteriaRow>
  //     {insertData && (
  //       <CriteriaRow css={{ marginTop: '5px' }}>
  //         <div
  //           style={{
  //             width: '100%',
  //             display: 'grid',
  //             gridTemplateColumns:
  //               'auto 150px auto 100px 100px 100px 100px 100px 100px 100px 100px 100px',
  //             gap: '5px',
  //           }}
  //         >
  //           <Label>Date :</Label>
  //           <DatePicker
  //             allowClear={false}
  //             format="MM/DD/YYYY"
  //             value={insertData.transdatemom}
  //             onChange={d => {
  //               setInsertData({
  //                 ...insertData,
  //                 transdatemom: d,
  //                 transdate: d.format('YYYY-MM-DD'),
  //               })
  //             }}
  //           />
  //           <Label>PNode :</Label>
  //           <Input
  //             value={insertData.pnodeid}
  //             onChange={e =>
  //               setInsertData({ ...insertData, pnodeid: e.target.value })
  //             }
  //           />
  //           <HourInputNumber hour={1} />
  //           <HourInputNumber hour={2} />
  //           <HourInputNumber hour={3} />
  //           <HourInputNumber hour={4} />
  //           <HourInputNumber hour={5} />
  //           <HourInputNumber hour={6} />
  //           <HourInputNumber hour={7} />
  //           <HourInputNumber hour={8} />
  //           <HourInputNumber hour={9} />
  //           <HourInputNumber hour={10} />
  //           <HourInputNumber hour={11} />
  //           <HourInputNumber hour={12} />
  //           <HourInputNumber hour={13} />
  //           <HourInputNumber hour={14} />
  //           <HourInputNumber hour={15} />
  //           <HourInputNumber hour={16} />
  //           <HourInputNumber hour={17} />
  //           <HourInputNumber hour={18} />
  //           <HourInputNumber hour={19} />
  //           <HourInputNumber hour={20} />
  //           <HourInputNumber hour={21} />
  //           <HourInputNumber hour={22} />
  //           <HourInputNumber hour={23} />
  //           <HourInputNumber hour={24} />
  //           <HourInputNumber hour={25} />
  //           <Button onClick={_ => onAdd(true)}>Add</Button>
  //           <Button onClick={_ => onAdd(false)}>Add & Hide</Button>
  //           <Button onClick={onCancel}>Cancel</Button>
  //         </div>
  //       </CriteriaRow>
  //     )}
  //     <FullHeightSizer heightOffset={230}>
  //       {({ height, width }) => (
  //         <Content style={{ height: height - 20 }}>
  //           <Grid
  //             ref={GridData}
  //             data={realTimeLMPData}
  //             headers={gridHeader}
  //             altBgColor="#ebebeb"
  //             render={virtualizedGridRenderer({
  //               autoFixColByKey: true,
  //               rowHeaderRender,
  //               height: height - 50,
  //               width: width - 150,
  //               headerRowHeight: 30,
  //             })}
  //             fuzzyFilter={fuzzyFilter}
  //           />
  //         </Content>
  //       )}
  //     </FullHeightSizer>
  //   </div>
  // )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
})

export default connect(mapStateToProps)(RealTimeLMP)
